export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_10.b98bbab1.mp4";